import ShoppinglistClient from '../clients/ShoppinglistClient';
import AbstractPilsComponent from './abstract-pils-component';
import pilsTypes from './pils-types';

export default class ToDefaultShoppingListToggle extends AbstractPilsComponent
{
    constructor(element, defaultShoppingListId)
    {
        super(element, pilsTypes.shopping_list);

        this._defaultShoppingListId = defaultShoppingListId;

        this._quantityInputSelectorFallback = '.js-to-default-shopping-list__quantity-input';
        this._removeFromShoppingListSelector = '.js-to-default-shopping-list__remove-button';
        this._addToShoppingListSelector = '.js-to-default-shopping-list__add-button';

        this._removeFromShoppingListButton = null;
        this._addToShoppingListButton = null;

        this._hiddenClass = 'hidden';

        this._shoppingListApiClient = new ShoppinglistClient();

        this.init();
    }

    init()
    {
        super.init();

        this._removeFromShoppingListButton = this.fetchRemoveButton();
        this._addToShoppingListButton = this.fetchAddButton();

        this.initEvents();
    }

    initEvents()
    {
        document.body.addEventListener(
            orion.constants.EventDefaultShoppingListChanged,
            this.handleDefaultShoppingListChanged.bind(this)
        );

        document.body.addEventListener(
            orion.constants.EventTilesviewVariationChanged,
            this.handleTilesViewVariationChanged.bind(this)
        );

        this._removeFromShoppingListButton.addEventListener(
            'click',
            this.handleRemoveButtonClick.bind(this)
        );

        this._addToShoppingListButton.addEventListener(
            'click',
            this.handleAddButtonClick.bind(this)
        );
    }

    handleDefaultShoppingListChanged(event)
    {
        this._defaultShoppingListId = event.detail.defaultShoppingListId;
    }

    handleTilesViewVariationChanged(event)
    {
        if (event.detail.currentProductNumber != this.productNumber) return;

        this.productNumber = event.detail.selectedProductNumber;
        this._element.dataset.pilsProductNumber = event.detail.selectedProductNumber;
    }

    fetchQuantityFromInput()
    {
        const quantityInput =
			document.getElementById(this._productNumber + '-quantity') ||
				document.querySelector(this._quantityInputSelectorFallback);

        if (!quantityInput) return 1;

        const quantity = parseInt(quantityInput.value, 10);
        return isNaN(quantity) || quantity < 1 ? 1 : quantity;
    }

    prepareDataForRequest()
    {
        let quantity = this.fetchQuantityFromInput();

        return {
            productItems: [
                {
                    productNumber: this._productNumber.toString(),
                    quantity: parseInt(quantity),
                    combineQuantities: true
                }
            ]
        };
    }

    hasShoppingList()
    {
        return this._defaultShoppingListId != '';
    }

    handleAddButtonClick()
    {
        if (!this.hasShoppingList())
        {
            this.createShoppingList(this.addProductToShoppingList);

            return;
        }

        this.addProductToShoppingList();
    }

    createShoppingList(afterRequestCallback)
    {
        let localeCode = orion.getLocaleCode().replace('_', '-');
        let shoppingListName = new Date().toLocaleDateString(
            localeCode, { day: '2-digit', month: '2-digit', year: 'numeric' }
        );

        let shoppingListData = {
            name: shoppingListName,
            isDefault: true
        };

        this._shoppingListApiClient.createShoppinglist(
            shoppingListData
        ).then(
            (response) => response.json()
        ).then((json) =>
        {
            let	defaultShoppingListId = json.productItemListId;
            this._defaultShoppingListId = defaultShoppingListId;

            let defaultListChangedEvent = new CustomEvent(
                orion.constants.EventDefaultShoppingListChanged,
                {
                    detail: {
                        defaultShoppingListId: defaultShoppingListId
                    }
                }
            );

            document.body.dispatchEvent(defaultListChangedEvent);

            afterRequestCallback.bind(this)();
        });
    }

    addProductToShoppingList()
    {
        let data = this.prepareDataForRequest();

        this._shoppingListApiClient.updateItems(
            data,
            this._defaultShoppingListId
        ).then(() =>
        {
            this.showRemoveButton();
            document.body.dispatchEvent(
                new CustomEvent(
                    orion.constants.EventShoppingListProductUpdated
                )
            );
        });
    }

    handleRemoveButtonClick()
    {
        let data = this.prepareDataForRequest();

        this._shoppingListApiClient.deleteItems(
            data,
            this._defaultShoppingListId
        ).then(() =>
        {
            this.showAddButton();
            $('body').trigger(orion.constants.EventShoppingListProductDeleted);
        });
    }

    update(data)
    {
        if (
            !data[this._productNumber] ||
			!data[this._productNumber][this._pilsType] ||
			!data[this._productNumber][this._pilsType][this._defaultShoppingListId]
        )
        {
            this.showAddButton();
            return;
        }

        this.showRemoveButton();
    }

    showAddButton()
    {
        this._addToShoppingListButton.classList.remove(this._hiddenClass);
        this._removeFromShoppingListButton.classList.add(this._hiddenClass);
    }

    showRemoveButton()
    {
        this._addToShoppingListButton.classList.add(this._hiddenClass);
        this._removeFromShoppingListButton.classList.remove(this._hiddenClass);
    }

    fetchAddButton()
    {
        return this._element.querySelector(this._addToShoppingListSelector);
    }

    fetchRemoveButton()
    {
        return this._element.querySelector(this._removeFromShoppingListSelector);
    }
}
